import { render, staticRenderFns } from "./ActionSendDevicesToCustomer.vue?vue&type=template&id=73e525dd&scoped=true&"
import script from "./ActionSendDevicesToCustomer.vue?vue&type=script&lang=js&"
export * from "./ActionSendDevicesToCustomer.vue?vue&type=script&lang=js&"
import style0 from "./ActionSendDevicesToCustomer.vue?vue&type=style&index=0&id=73e525dd&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73e525dd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
import { VTabsSlider } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBtn,VCard,VTab,VTabItem,VTabs,VTabsItems,VTabsSlider})
